<template>
    <div>
        <v-snackbar
            v-model="is_visible"
            :color="type"
            :timeout="timeout"
            app
            top
            right>
            {{ message }}

            <template
                v-slot:action="{ attrs }">
                <v-btn
                    v-show="is_action_visible"
                    v-bind="attrs"
                    @click="action">
                    {{ action_text }}
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
export default {
    data() {
        return {
            timeout          : -1,
            type             : 'success',
            is_visible       : false,
            message          : '',
            is_action_visible: false,
            action_text      : '',
            action_cb        : function() {
            }
        };
    },
    methods: {
        action() {
            this.action_cb();
            this.is_visible = false;
        }
    }
};
</script>
